// extracted by mini-css-extract-plugin
var _1 = "tjs-file-input__btn tjs-_buttons__btn tjs-_buttons__btn-primary";
var _2 = "tjs-file-input__btn--hover tjs-_buttons__btn-primary--hover";
var _3 = "tjs-file-input__btn--hover tjs-_buttons__btn-primary--hover";
var _4 = "tjs-file-input__file-input";
var _5 = "tjs-file-input__file-input";
var _6 = "tjs-file-input__input";
export { _1 as "btn", _2 as "btn--hover", _3 as "btnHover", _4 as "file-input", _5 as "fileInput", _6 as "input" }
export default { "btn": _1, "btn--hover": _2, "btnHover": _3, "file-input": _4, "fileInput": _5, "input": _6 }
